import PodBox from "pod-box-sdk";
import { useHistory } from "react-router-dom";

import { MyAccountSection } from "../styled";
import { numberWithCommas } from "../../../utils";
import { getBalance } from "../../../services";
import { useFetch } from "../../../hooks";
import { Button } from "../../../components";

export const MyAccount = () => {
  const [balance, balanceError] = useFetch(getBalance);
  const [user, userError] = useFetch(() => PodBox.user.getInfo(), {
    resolver: (data) => data.result,
  });

  const { push } = useHistory();

  return (
    <MyAccountSection>
      {!userError && (
        <div className="right-side">
          {user ? (
            <img
              className="avatar"
              src={user.profileImage}
              alt={user.firstName}
            />
          ) : (
            <div className="avatar" />
          )}
          {user ? (
            <div className="user-info">
              <h3>
                {user.firstName} {user.lastName}
              </h3>
              <h5>
                اعتبار فعلی :{" "}
                <span>
                  {balance && !balanceError
                    ? numberWithCommas(balance.amount / 10)
                    : ". . ."}{" "}
                  تومان
                </span>
              </h5>
            </div>
          ) : (
            ". . ."
          )}
        </div>
      )}
      <div className="left-side">
        <Button
          onClick={() => {
            push("/payments-history");
          }}
          color="green"
        >
          تاریخچه پرداخت ها
        </Button>
        <Button
          onClick={() => {
            push("/scheduled-payments");
          }}
          className="margin-top-2"
          color="grey"
        >
          پرداخت های برنامه ریزی شده
        </Button>
      </div>
    </MyAccountSection>
  );
};
